import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { SettingsComponent } from './settings.component';
import { BaseUrlComponent } from './components/base-url/base-url.component';
import { WasabiFunctionsComponent } from './components/wasabi-functions/wasabi-functions.component';
import { canEditPipe } from './components/wasabi-functions/wasabi-utils';
import { TimeoutEventComponent } from './components/timeout-event/timeout-event.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  declarations: [
    SettingsComponent,
    BaseUrlComponent,
    TimeoutEventComponent,
    BaseUrlComponent,
    WasabiFunctionsComponent,
    canEditPipe
  ],
  exports: [
    SettingsComponent,
    BaseUrlComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class SettingsModule { }
